<template>
  <div>
    <NavTop class="navbar">
    </Navtop>
    <!-- 内容 -->
    <div class=" box content">
      <div class="box_">
        <div class="box_t">
          <div class="box_t_l">详情</div>
          <div class="box_t_r">
            <span @click="goHome">首页</span>/
            <span>河北东方学院</span>
          </div>
        </div>
        <div class="box_b">
          <div class="box_b_title">{{ detailData.title }}</div>
          <div class="box_b_time">作者： {{ detailData.authorName }} | {{ extractDate(detailData.publishTime) }}</div>
          <div v-if="detailData.introduce" class="ql-editor" v-html="detailData.introduce"></div>
          <div v-if="detailData.content" class="ql-editor" v-html="detailData.content"></div>

          <div v-for="(item,index) in attachment" :key="index">
            <el-link class="fujian" :underline="false" v-if="item.url" @click="downFile(item)"  target="_blank" type="primary">
              {{ item.title }}
            </el-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import home from '../../../api/home'

export default {
  data () {
    return {
      detailData: {},
      // 附件
      attachment: []
    }
  },
  mounted () {

  },
  beforeDestroy () {

  },
  created () {
    this.getDetail(this.$route.params.id)
  },
  methods: {
    downFile(item){
      let id = this.$route.params.id;
      if (id==30331||id==30267){
        this.$prompt('请输入下载密码', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: '下载密码不正确'
        }).then(({ value }) => {
          if (value==123456) {
            location.href = item.url
          }
        })
      }else {
        location.href = item.url
      }

    },
    async  getDetail (id) {
      const res = await  home.getDetail({id: id});
      this.detailData = res.data
      let arr = res.data.attachment.split(',')
      this.attachment = [];
      console.log(arr)
      arr.forEach(item => {
        // 提取不带后缀的文件名
        const fullName = item.split("/").pop();
        const nameWithoutExt = fullName.substring(0, fullName.lastIndexOf("."));
        this.attachment.push({
          url: item,
          title:nameWithoutExt
        })
      })

    },
    // 截取日期
    extractDate (dateTimeStr) {
      if (dateTimeStr) {
        // 使用空格分割日期和时间
        const parts = dateTimeStr.split(' ')
        // 返回日期部分
        return parts[0]
      }
    },
    // 去首页
    goHome () {
      this.$router.push('/')
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  width: 1200px;
  margin: 0 auto;
}

.box {
  margin-top: 50px;
  margin-bottom: 50px;
  display: flex;
  justify-content: space-between;

  .box_ {
    width: 1200px;

    .box_t {
      height: 45px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #eee;

      .box_t_l {
        padding: 0 15px;
        line-height: 45px;
        font-size: 20px;
        font-weight: bold;
        color: #444;
        border-bottom: 2px solid #9e070e;
      }

      .box_t_r {
        font-size: 14px;
        color: #666;

        span {
          &:nth-child(1):hover {
            cursor: pointer;
            text-decoration: underline;
          }
        }
      }
    }

    .box_b {
      .box_b_title {
        line-height: 40px;
        font-size: 18px;
        font-weight: bold;
      }

      .box_b_time {
        line-height: 30px;
        font-size: 14px;
        color: #666;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/search/detail/detail.vue